import { observer } from 'mobx-react-lite'
import { ReactElement, useEffect } from 'react'
import Drawer from '../drawer/Drawer'
import Spinner from '../Spinner'
import { ActivityInfo } from './ActivityInfo'
import type { ActivityJson } from 'app/types/entities'
import { useLocationStore } from 'app/stores/StoreContext'

type Props = {
  activity?: ActivityJson
  isLoading?: boolean
  open: boolean
  onChange?: (id: string) => void
  onClose: () => void
  onContactClick?: (contactId: string) => void
}

export const ActivityDrawer = observer(function ActivityDrawer({
  activity,
  isLoading,
  open,
  onChange,
  onClose,
  onContactClick,
}: Props): ReactElement {
  const locationStore = useLocationStore()

  useEffect(() => {
    if (activity?.locationId) {
      locationStore.fetchOne(activity.locationId)
    }
  }, [activity?.locationId])

  const location = locationStore.current?.id === activity?.locationId ? locationStore.current : undefined

  return (
    <Drawer
      open={open}
      title="Activity Details"
      leftContent={
        <div className="w-full md:w-[680px]">
          {isLoading ? (
            <div className={`flex h-full items-center justify-center`}>
              <Spinner size={20} />
            </div>
          ) : (
            <ActivityInfo
              activity={activity}
              location={location as any}
              onChange={onChange}
              onContactClick={onContactClick}
            />
          )}
        </div>
      }
      canExpand={false}
      onClose={onClose}
    />
  )
})
